import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    DATE_RANGE_FIELD_TYPE,
    AUTOCOMPLETE_FIELD_TYPE,
    BOOLEAN_FIELD_TYPE,
} from "../../helpers/constants";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import {UpdateClauseDialog} from "./UpdateClauseDialog"

import DateService from "../../services/dateService";
import SelectFieldService from "../../services/selectFieldService";

export const CLAUSE_TABLE_NAME = "clause_table";

export const useClauseTableFieldsConfig = () => {
    const { t } = useTranslation();

      const { openDialog: openUpdateClauseDialog } = useDialogBetter();
    
      const handleClickEdit = (e, clauseId) => {
        e.stopPropagation();
        e.preventDefault();
        openUpdateClauseDialog({
          Component: UpdateClauseDialog,
          componentProps: {
            clauseId: clauseId,
          },
        });
      };


    return [
        {
            name: "clause_name",
            getValueCallback: (rowData) => rowData.clause_name,
            label: t("page.clause_page.clause_name"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "clause_text",
            getValueCallback: (rowData) => rowData.clause_text,
            label: t("page.clause_page.clause_text"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "clause_tag",
            getValueCallback: (rowData) => rowData.clause_tag,
            label: t("page.clause_page.clause_tag"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "created",
            getValueCallback: (rowData) =>
                DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.created),
            label: t("page.clause_page.created"),
            filterType: DATE_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => ({
                style: { minWidth: "100px" },
            }),
        },
        {
            name: "creator",
            getValueCallback: (rowData) => rowData.creator,
            label: t("page.clause_page.creator"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "clause_is_required",
            getValueCallback: (rowData) => SelectFieldService.getLabelOptionsTrueOrFalse(rowData.clause_is_required),
            label: t("page.clause_page.clause_is_required"),
            filterType: BOOLEAN_FIELD_TYPE,
        },
        {
            name: "clause_is_temporary",
            getValueCallback: (rowData) => SelectFieldService.getLabelOptionsTrueOrFalse(rowData.clause_is_temporary),
            label: t("page.clause_page.clause_is_temporary"),
            filterType: BOOLEAN_FIELD_TYPE,
        },
        {
            name: "clause_order",
            getValueCallback: (rowData) => rowData.clause_order,
            label: t("page.clause_page.clause_order"),
            filterType: null,
        },
        {
            name: "clause_active",
            getValueCallback: (rowData) => SelectFieldService.getLabelOptionsTrueOrFalse(rowData.clause_active),
            label: t("page.clause_page.clause_active"),
            filterType: BOOLEAN_FIELD_TYPE,
        },
        {
            name: "edit_button",
            getValueCallback: (rowData) => (
                <IconButton
                    disabled={rowData.clause_is_temporary}
                    color={"primary"}
                    onClick={(e) => handleClickEdit(e, rowData.id)}
                >
                    <EditIcon />
                </IconButton>
            ),
            label: t("edit"),
            allowChangeVisibility: false,
            excludedFromExport: true,
        },
    ];
};
